var app = new Vue({
  el: "#app",
  data: {
    questions: [],
    currentQuestion: 0,
    totalQuestions: 0,
    progress: 0,
    userAnswers: {},
    base_score: 0,
    score_cuir: 0,
    score_longueurs: 0,
    score_racines: 0,
    score_fibres: 0,
    score_pointes: 0,
    score_volume: 0,
    score_total: 0,
    res_cuir_cair_type: "",
    res_cuir_ingredients: "",
    res_cuir_utilisation: "",
    res_longueurs_cair_type: "",
    res_longueurs_ingredients: "",
    res_longueurs_utilisation: "",
    res_racines_cair_type: "",
    res_racines_ingredients: "",
    res_racines_utilisation: "",
    res_fibres_cair_type: "",
    res_fibres_ingredients: "",
    res_fibres_utilisation: "",
    res_pointes_cair_type: "",
    res_pointes_ingredients: "",
    res_pointes_utilisation: "",
    res_volume_cair_type: "",
    res_volume_ingredients: "",
    res_volume_utilisation: "",
    lowestScoreMessage: "",
    lowestScoreDescription: "",
    is_email_form_hidden: true,
    is_results_hidden: true,
    debugMode: false,
    variantIdSerum: 0,
    variantIdMasque: 0,
    variantIdShampoing: 0,
    variantIdShampoingB: 0,
    variantIdBrume: 0,
    variantIdHuile: 0,
    variantIdCreme: 0,
    variantIdEauDeSoin: 0,
    handleSerum: '',
    handleMasque: '',
    handleShampoing: '',
    handleShampoingB: '',
    handleBrume: '',
    handleHuile: '',
    handleCreme: '',
    handleBrosse: '',
    handleEauDeSoin: '',
  },

  computed: {
    Question: function () {
      return this.questions[this.currentQuestion];
    },

    isNextDisabled: function () {
      const currentQuestionId = this.questions[this.currentQuestion].id;
      // Vérifie si la question à choix unique a une réponse
      if (this.questions[this.currentQuestion].type === "single") {
        return !this.userAnswers.hasOwnProperty(currentQuestionId);
      }
      // Vérifie si la question à choix multiples a au moins une réponse
      else if (this.questions[this.currentQuestion].type === "multiple") {
        return !this.userAnswers.hasOwnProperty(currentQuestionId) || this.userAnswers[currentQuestionId].length === 0;
      }
    },

    progressBarWidthGlobal: function () {
      return "calc(100% - " + this.score_total + "%)";
    },

    progressBarWidthCuir: function () {
      if (this.score_cuir < 0) {
        return "100%";
      } else {
        return "calc(100% - " + this.score_cuir + "%";
      }
    },

    progressBarWidthLongueurs: function () {
      if (this.score_longueurs < 0) {
        return "100%";
      } else {
        return "calc(100% - " + this.score_longueurs + "%";
      }
    },

    progressBarWidthRacines: function () {
      if (this.score_racines < 0) {
        return "100%";
      } else {
        return "calc(100% - " + this.score_racines + "%";
      }
    },

    progressBarWidthFibres: function () {
      if (this.score_fibres < 0) {
        return "100%";
      } else {
        return "calc(100% - " + this.score_fibres + "%";
      }
    },

    progressBarWidthPointes: function () {
      if (this.score_pointes < 0) {
        return "100%";
      } else {
        return "calc(100% - " + this.score_pointes + "%";
      }
    },

    progressBarWidthVolume: function () {
      if (this.score_volume < 0) {
        return "100%";
      } else {
        return "calc(100% - " + this.score_volume + "%";
      }
    },

    recommendedProducts: function () {
      var products = [];
      // Sérum ou masque selon le score
      if (this.score_cuir <= this.score_pointes) {
        products.push(this.handleSerum);
      } else {
        products.push(this.handleMasque);
      }
      // Shampoing A si score volume < 62, shampoing B sinon
      products.push(this.score_volume < 62 ? this.handleShampoing : this.handleShampoingB);
      products.push(this.handleBrume);
      if (this.score_longueurs < 45) {
        products.push(this.handleHuile);
      }
      if (this.score_volume == 62) {
        products.push(this.handleEauDeSoin);
      }
      products.push(this.handleCreme);
      products.push(this.handleBrosse);
      return products;
    },

    routineItems: function () {
      var items = [];
      // Sérum si cuir chevelu est le plus faible, sinon masque
      if (this.score_cuir <= this.score_pointes) {
        items.push({"id": this.variantIdSerum, "quantity": 1});
      } else {
        items.push({"id": this.variantIdMasque, "quantity": 1});
      }
      items.push({"id": this.score_volume < 62 ? this.variantIdShampoing : this.variantIdShampoingB, "quantity": 1});
      items.push({"id": this.variantIdBrume, "quantity": 1});
      if (this.score_longueurs < 45) {
        items.push({"id": this.variantIdHuile, "quantity": 1});
      }
      if (this.score_volume == 62) {
        items.push({"id": this.variantIdEauDeSoin, "quantity": 1});
      }
      items.push({"id": this.variantIdCreme, "quantity": 1});
      return JSON.stringify(items);
    },
  },

  created: function () {
    var lang = document.querySelector('html').lang;
    var suffix = { es: '-es', de: '-de', it: '-it', en: '-en' }[lang] || '';
    var url = "https://cdn.shopify.com/s/files/1/0508/5147/9701/files/questionnaire-10-2026" + suffix + ".json?v=2";

    this.fetchData(url);

    // DEBUG: Ajouter ?debug dans l'URL pour afficher le bouton "Skip to results"
    if (window.location.search.includes('debug')) {
      this.debugMode = true;
    }
  },

  mounted: function () {
    var el = this.$el;
    this.variantIdSerum = parseInt(el.dataset.variantSerum);
    this.variantIdMasque = parseInt(el.dataset.variantMasque);
    this.variantIdShampoing = parseInt(el.dataset.variantShampoing);
    this.variantIdShampoingB = parseInt(el.dataset.variantShampoingB) || this.variantIdShampoing;
    this.variantIdBrume = parseInt(el.dataset.variantBrume);
    this.variantIdHuile = parseInt(el.dataset.variantHuile);
    this.variantIdCreme = parseInt(el.dataset.variantCreme);
    this.variantIdEauDeSoin = parseInt(el.dataset.variantEauDeSoin);
    this.handleSerum = el.dataset.handleSerum || '';
    this.handleMasque = el.dataset.handleMasque || '';
    this.handleShampoing = el.dataset.handleShampoing || '';
    this.handleShampoingB = el.dataset.handleShampoingB || this.handleShampoing;
    this.handleBrume = el.dataset.handleBrume || '';
    this.handleHuile = el.dataset.handleHuile || '';
    this.handleCreme = el.dataset.handleCreme || '';
    this.handleBrosse = el.dataset.handleBrosse || '';
    this.handleEauDeSoin = el.dataset.handleEauDeSoin || '';
  },

  methods: {
    // Récupérer les données du JSON
    fetchData: function (url) {
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          this.questions = data[0].questions;
          this.base_score = parseInt(data[0].base_score);
          this.totalQuestions = data[0].questions.length;
          this.updateProgress();
        })
        .catch((error) => console.error("Erreur de chargement du JSON:", error));
    },

    // Question suivante
    nextQuestion: function () {
      if (this.currentQuestion < this.totalQuestions - 1) {
        this.currentQuestion++;
        this.updateProgress();
        // Si la question suivante est la dernière, affiche la section des résultats
      } else if (this.currentQuestion === this.totalQuestions - 1) {
        this.is_email_form_hidden = false; // Affiche la section du formulaire email
        document.querySelector('.klaviyo_diagnostic_wrapper').style.display = "block";
      }
    },

    // Afficher les résultats
    showResult: function () {
      this.is_results_hidden = false;

      // Utilisez $nextTick pour vous assurer que l'élément avec l'ID "score" est rendu dans le DOM
      this.$nextTick(() => {
        const progressBar = document.getElementById("circular_progress_bar");
        if (progressBar) {
          this.circularProgressbar();
          this.calculateDashOffsets();
          this.lowestScore();
        }
      });
    },

    // Question précédente
    previousQuestion: function () {
      if (this.currentQuestion > 0) {
        this.currentQuestion--;
        this.updateProgress();
      }
    },

    // Dernière question
    lastQuestion: function () {
      this.currentQuestion == this.totalQuestions - 1;
      this.updateProgress();
      this.is_email_form_hidden = true;
    },

    // Mise à jour de la progression
    updateProgress: function () {
      this.progress = ((this.currentQuestion + 1) / this.totalQuestions) * 100;
    },

    // Enregistrer la réponse de l'utilisateur
    recordAnswer: function (questionIndex, answerIndex) {
      // Récupère la question concernée
      const question = this.questions.find((q) => q.id === questionIndex);

      if (question.type === "single") {
        // Pour les choix uniques, stocke simplement l'index de la réponse
        this.$set(this.userAnswers, questionIndex, answerIndex);
      } else if (question.type === "multiple") {
        // Pour les choix multiples, initialise un tableau si ce n'est pas déjà fait
        if (!this.userAnswers[questionIndex]) {
          this.$set(this.userAnswers, questionIndex, []);
        }

        // Récupère l'élément de réponse actuel
        const checkbox = document.getElementById(questionIndex + "-" + answerIndex);

        if (checkbox.checked) {
          // Si la case est cochée, ajoute l'index de la réponse au tableau
          this.userAnswers[questionIndex].push(answerIndex);
        } else {
          // Si la case est décochée, retire l'index de la réponse du tableau
          const answerIndexToRemove = this.userAnswers[questionIndex].indexOf(answerIndex);
          if (answerIndexToRemove > -1) {
            this.userAnswers[questionIndex].splice(answerIndexToRemove, 1);
          }
        }
      }

      this.calculateScore();
    },

    // Calculer le score
    calculateScore: function () {
      this.score_cuir = this.base_score;
      this.score_longueurs = this.base_score;
      this.score_racines = this.base_score;
      this.score_fibres = this.base_score;
      this.score_pointes = this.base_score;
      this.score_volume = this.base_score;

      this.res_cuir_cair_type = "";
      this.res_cuir_ingredients = "";
      this.res_cuir_utilisation = "";
      this.res_longueurs_cair_type = "";
      this.res_longueurs_ingredients = "";
      this.res_longueurs_utilisation = "";
      this.res_racines_cair_type = "";
      this.res_racines_ingredients = "";
      this.res_racines_utilisation = "";
      this.res_fibres_cair_type = "";
      this.res_fibres_ingredients = "";
      this.res_fibres_utilisation = "";
      this.res_pointes_cair_type = "";
      this.res_pointes_ingredients = "";
      this.res_pointes_utilisation = "";
      this.res_volume_cair_type = "";
      this.res_volume_ingredients = "";
      this.res_volume_utilisation = "";
      this.is_negative = false;

      // Parcourt les réponses de l'utilisateur
      for (const questionId in this.userAnswers) {
        // Question après question
        const question = this.questions.find((q) => q.id === questionId);

        if (question) {
          const category = question.category;

          // Pour les choix uniques, ajoute le score de la réponse sélectionnée
          if (question.type === "single") {
            const answerIndex = this.userAnswers[questionId];
            const selectedAnswer = question.answers[answerIndex];

            switch (category) {
              case "cuir":
                this.score_cuir += parseInt(selectedAnswer.score);
                this.res_cuir_cair_type += selectedAnswer.cair_type + " ";
                this.res_cuir_ingredients += selectedAnswer.ingredients + " ";
                this.res_cuir_utilisation += selectedAnswer.utilisation + " ";
                break;
              case "longueurs":
                this.score_longueurs += parseInt(selectedAnswer.score);
                this.res_longueurs_cair_type += selectedAnswer.cair_type + " ";
                this.res_longueurs_ingredients += selectedAnswer.ingredients + " ";
                this.res_longueurs_utilisation += selectedAnswer.utilisation + " ";
                break;
              case "racines":
                this.score_racines += parseInt(selectedAnswer.score);
                this.res_racines_cair_type += selectedAnswer.cair_type + " ";
                this.res_racines_ingredients += selectedAnswer.ingredients + " ";
                this.res_racines_utilisation += selectedAnswer.utilisation + " ";
                break;
              case "fibres":
                this.score_fibres += parseInt(selectedAnswer.score);
                this.res_fibres_cair_type += selectedAnswer.cair_type + " ";
                this.res_fibres_ingredients += selectedAnswer.ingredients + " ";
                this.res_fibres_utilisation += selectedAnswer.utilisation + " ";
                break;
              case "pointes":
                this.score_pointes += parseInt(selectedAnswer.score);
                this.res_pointes_cair_type += selectedAnswer.cair_type + " ";
                this.res_pointes_ingredients += selectedAnswer.ingredients + " ";
                this.res_pointes_utilisation += selectedAnswer.utilisation + " ";
                break;
              case "volume":
                this.score_volume += parseInt(selectedAnswer.score);
                this.res_volume_cair_type += selectedAnswer.cair_type + " ";
                this.res_volume_ingredients += selectedAnswer.ingredients + " ";
                this.res_volume_utilisation += selectedAnswer.utilisation + " ";
                break;
            }
          }
          // Pour les choix multiples
          else if (question.type === "multiple") {
            for (const answerIndex of this.userAnswers[question.id]) {
              switch (category) {
                case "cuir":
                  this.score_cuir += parseInt(question.answers[answerIndex].score);
                  //this.score_cuir += parseInt(question.answers[answerIndex].score);
                  this.res_cuir_cair_type += question.answers[answerIndex].cair_type + " ";
                  this.res_cuir_ingredients += question.answers[answerIndex].ingredients + " ";
                  this.res_cuir_utilisation += question.answers[answerIndex].utilisation + " ";
                  break;
                case "longueurs":
                  this.score_longueurs += parseInt(question.answers[answerIndex].score);
                  this.res_longueurs_cair_type += question.answers[answerIndex].cair_type + " ";
                  this.res_longueurs_ingredients += question.answers[answerIndex].ingredients + " ";
                  this.res_longueurs_utilisation += question.answers[answerIndex].utilisation + " ";
                  break;
                case "racines":
                  this.score_racines += parseInt(question.answers[answerIndex].score);
                  //this.score_racines += parseInt(question.answers[answerIndex].score);
                  this.res_racines_cair_type += question.answers[answerIndex].cair_type + " ";
                  this.res_racines_ingredients += question.answers[answerIndex].ingredients + " ";
                  this.res_racines_utilisation += question.answers[answerIndex].utilisation + " ";
                  break;
                case "fibres":
                  this.score_fibres += parseInt(question.answers[answerIndex].score);
                  //this.score_fibres += parseInt(question.answers[answerIndex].score);
                  this.res_fibres_cair_type += question.answers[answerIndex].cair_type + " ";
                  this.res_fibres_ingredients += question.answers[answerIndex].ingredients + " ";
                  this.res_fibres_utilisation += question.answers[answerIndex].utilisation + " ";
                  break;
                case "pointes":
                  this.score_pointes += parseInt(question.answers[answerIndex].score);
                  //this.score_pointes += parseInt(question.answers[answerIndex].score);
                  this.res_pointes_cair_type += question.answers[answerIndex].cair_type + " ";
                  this.res_pointes_ingredients += question.answers[answerIndex].ingredients + " ";
                  this.res_pointes_utilisation += question.answers[answerIndex].utilisation + " ";
                  break;
                case "volume":
                  this.score_volume += parseInt(question.answers[answerIndex].score);
                  this.res_volume_cair_type += question.answers[answerIndex].cair_type + " ";
                  this.res_volume_ingredients += question.answers[answerIndex].ingredients + " ";
                  this.res_volume_utilisation += question.answers[answerIndex].utilisation + " ";
                  break;
              }
            }
          }
        }
      }

      // Score total
      this.score_total = parseInt((this.score_cuir + this.score_longueurs + this.score_racines + this.score_fibres + this.score_pointes + this.score_volume) / 6);
    },

    // Déterminer le score le plus bas
    lowestScore: function () {
      const scores = [this.score_cuir, this.score_longueurs, this.score_racines, this.score_fibres, this.score_pointes, this.score_volume];
      const minScore = Math.min(...scores);
      var lang = document.querySelector('html').lang;

      var messages = {
        cuir: {
          fr: "Dans votre cas, votre cuir chevelu est fragilisé. Comment régler mon problème de cuir chevelu ?",
          en: "In your case, your scalp is weakened. How can I fix my scalp issue?",
          de: "In Ihrem Fall ist Ihre Kopfhaut geschwächt. Wie kann ich mein Kopfhautproblem lösen?",
          it: "Nel suo caso, il cuoio capelluto è indebolito. Come posso risolvere il mio problema al cuoio capelluto?",
          es: "En su caso, el cuero cabelludo está debilitado. ¿Cómo puedo solucionar mi problema del cuero cabelludo?"
        },
        longueurs: {
          fr: "Dans votre cas, vos longueurs sont abîmées. Comment régler mon problème de longueurs ?",
          en: "In your case, your lengths are damaged. How can I fix my lengths?",
          de: "In Ihrem Fall sind Ihre Längen geschädigt. Wie kann ich mein Längenproblem lösen?",
          it: "Nel suo caso, le lunghezze sono danneggiate. Come posso risolvere il problema delle lunghezze?",
          es: "En su caso, los largos están dañados. ¿Cómo puedo solucionar mi problema de largos?"
        },
        racines: {
          fr: "Dans votre cas, vos racines manquent de tonus. Comment régler mon problème de racines ?",
          en: "In your case, your roots lack volume. How can I fix my roots?",
          de: "In Ihrem Fall fehlt es Ihren Ansätzen an Spannkraft. Wie kann ich mein Ansatzproblem lösen?",
          it: "Nel suo caso, le radici mancano di tono. Come posso risolvere il problema delle radici?",
          es: "En su caso, las raíces carecen de volumen. ¿Cómo puedo solucionar mi problema de raíces?"
        },
        fibres: {
          fr: "Dans votre cas, vos fibres sont abîmées. Comment régler mon problème de fibres ?",
          en: "In your case, your hair fibers are damaged. How can I fix my hair fibers?",
          de: "In Ihrem Fall sind Ihre Haarfasern geschädigt. Wie kann ich mein Haarfaserproblem lösen?",
          it: "Nel suo caso, le fibre capillari sono danneggiate. Come posso risolvere il problema delle fibre capillari?",
          es: "En su caso, las fibras capilares están dañadas. ¿Cómo puedo solucionar mi problema de fibras capilares?"
        },
        pointes: {
          fr: "Dans votre cas, vos pointes sont abîmées. Comment régler mon problème de pointes ?",
          en: "In your case, your ends are damaged. How can I fix my ends?",
          de: "In Ihrem Fall sind Ihre Spitzen geschädigt. Wie kann ich mein Spitzenproblem lösen?",
          it: "Nel suo caso, le punte sono danneggiate. Come posso risolvere il problema delle punte?",
          es: "En su caso, las puntas están dañadas. ¿Cómo puedo solucionar mi problema de puntas?"
        },
        volume: {
          fr: "Dans votre cas, vos cheveux manquent de volume. Comment régler mon problème de volume ?",
          en: "In your case, your hair lacks volume. How can I fix my volume issue?",
          de: "In Ihrem Fall fehlt es Ihrem Haar an Volumen. Wie kann ich mein Volumenproblem lösen?",
          it: "Nel suo caso, i capelli mancano di volume. Come posso risolvere il problema di volume?",
          es: "En su caso, su cabello carece de volumen. ¿Cómo puedo solucionar mi problema de volumen?"
        }
      };

      var msgLang = messages.cuir[lang] ? lang : "en";

      if (minScore === this.score_cuir) {
        this.lowestScoreMessage = messages.cuir[msgLang];
        this.lowestScoreDescription = this.res_cuir_ingredients;
      } else if (minScore === this.score_longueurs) {
        this.lowestScoreMessage = messages.longueurs[msgLang];
        this.lowestScoreDescription = this.res_longueurs_ingredients;
      } else if (minScore === this.score_racines) {
        this.lowestScoreMessage = messages.racines[msgLang];
        this.lowestScoreDescription = this.res_racines_ingredients;
      } else if (minScore === this.score_fibres) {
        this.lowestScoreMessage = messages.fibres[msgLang];
        this.lowestScoreDescription = this.res_fibres_ingredients;
      } else if (minScore === this.score_pointes) {
        this.lowestScoreMessage = messages.pointes[msgLang];
        this.lowestScoreDescription = this.res_pointes_ingredients;
      } else if (minScore === this.score_volume) {
        this.lowestScoreMessage = messages.volume[msgLang];
        this.lowestScoreDescription = this.res_volume_ingredients;
      }
    },

    // Circular progressbar animation score
    circularProgressbar: function () {
      this.number = document.getElementById("score");
      this.counter = 0;

      // Stocker l'ID de l'intervalle
      this.progressInterval = setInterval(() => {
        if (this.counter >= this.score_total) {
          clearInterval(this.progressInterval);
        } else {
          this.counter++;
          this.number.textContent = this.counter + "%";
        }
      }, 10);
    },

    // Animation circular progressbar
    calculateDashOffsets() {
      // Calculer la valeur de --stroke-dashoffset en fonction de score_total
      const strokeDashOffset = 780 - 780 * (this.score_total / 100);
      return strokeDashOffset; // Utilisez l'unité appropriée ici
    },

    // DEBUG: Simuler des réponses et afficher les résultats directement
    skipToResults: function () {
      // Attendre que les questions soient chargées
      if (this.questions.length === 0) {
        setTimeout(() => this.skipToResults(), 100);
        return;
      }

      // Simuler une réponse pour chaque question
      this.questions.forEach((question) => {
        if (question.type === "single") {
          // Choisir une réponse aléatoire
          const randomIndex = Math.floor(Math.random() * question.answers.length);
          this.$set(this.userAnswers, question.id, randomIndex);
        } else if (question.type === "multiple") {
          // Choisir 1 à 2 réponses aléatoires
          const indices = [];
          const numAnswers = Math.min(2, question.answers.length);
          while (indices.length < numAnswers) {
            const randomIndex = Math.floor(Math.random() * question.answers.length);
            if (!indices.includes(randomIndex)) {
              indices.push(randomIndex);
            }
          }
          this.$set(this.userAnswers, question.id, indices);
        }
      });

      // Calculer les scores
      this.calculateScore();

      // Afficher les résultats
      this.is_email_form_hidden = true;
      this.showResult();

      /* console.log('DEBUG - Scores simulés:', {
        cuir: this.score_cuir,
        longueurs: this.score_longueurs,
        racines: this.score_racines,
        fibres: this.score_fibres,
        pointes: this.score_pointes,
        total: this.score_total
      }); */
    },
  },

  watch: {
    score_total: {
      handler() {
        // Appeler calculateDashOffsets() pour obtenir la nouvelle valeur
        const strokeDashOffset = this.calculateDashOffsets();

        // Mettre à jour la propriété dans les données Vue
        this.strokeDashOffset = strokeDashOffset;
      },
      immediate: true, // Appel immédiat lors de la création du composant pour initialiser les valeurs
    },
  },
});

document.addEventListener('DOMContentLoaded', function () {

  // On click on button of klaviyo-form, submit the form
  document.addEventListener('click', function (event) {
    if (event.target.matches('#email_form .klaviyo-form button')){
      var formulaire_input = document.querySelector('#email_form .klaviyo-form input[type="email"]');
      // delay of 3 seconds
      setTimeout(() => {
        submitKlavyio(formulaire_input);
      }, 2000);
    }
  });

  document.addEventListener('submit', function (event) {
    if (event.target.matches('#email_form .klaviyo-form')){
      var formulaire_input = document.querySelector('#email_form .klaviyo-form input[type="email"]');
      setTimeout(() => {
        submitKlavyio(formulaire_input);
      }, 2000);
    }
  });
});


function submitKlavyio(formulaire_input){
  if (typeof app !== 'undefined' && app.showResult) {
    app.showResult();

    if (typeof klaviyo !== 'undefined') {
      klaviyo.identify({
        'email': formulaire_input.value
      }).then(() =>
        klaviyo.push(['track', 'Diagnostic', {
          'Score Total': app.score_total,
          'Lowest Score Message': app.lowestScoreMessage,
          'Lowest Score Description': app.lowestScoreDescription,
          'Score Cuir': app.score_cuir,
          'Score Longueurs': app.score_longueurs,
          'Score Racines': app.score_racines,
          'Score Fibres': app.score_fibres,
          'Score Pointes': app.score_pointes,
          'Score Volume': app.score_volume,
          'Cuir Type': app.res_cuir_cair_type,
          'Cuir Ingredients': app.res_cuir_ingredients,
          'Cuir Utilisation': app.res_cuir_utilisation,
          'Longueurs Type': app.res_longueurs_cair_type,
          'Longueurs Ingredients': app.res_longueurs_ingredients,
          'Longueurs Utilisation': app.res_longueurs_utilisation,
          'Racines Type': app.res_racines_cair_type,
          'Racines Ingredients': app.res_racines_ingredients,
          'Racines Utilisation': app.res_racines_utilisation,
          'Fibres Type': app.res_fibres_cair_type,
          'Fibres Ingredients': app.res_fibres_ingredients,
          'Fibres Utilisation': app.res_fibres_utilisation,
          'Pointes Type': app.res_pointes_cair_type,
          'Pointes Ingredients': app.res_pointes_ingredients,
          'Pointes Utilisation': app.res_pointes_utilisation,
          'Volume Type': app.res_volume_cair_type,
          'Volume Ingredients': app.res_volume_ingredients,
          'Volume Utilisation': app.res_volume_utilisation,
          'Recommended Products': app.recommendedProducts
        }])
      );
    }

    // remonter en haut de la fenetre de manière smooth
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}